import React, {FC} from 'react';
import {Navigate, useLocation} from 'react-router-native';

// Paths inlined on purpose: this component is referenced by routes.definition (via routes.components),
// so importing Path back from routes.definition here closes a load-order-sensitive dependency cycle
// that can resolve to `undefined`. The literals are kept honest by the tests, which route to the real
// Paths and fail on any drift.
const FAQS_PATH = '/faqs';
const LOGIN_PATH = '/login';
const SUPPORT_PATH = '/support';

/**
 * Registered at `/support` for anonymous users only. A visitor arriving with a `conversation` param
 * came from the chat's login link and must resume that conversation after signing in, so they are
 * sent to /login (which returns to /support?conversation=… and resumes). Everyone else — arriving at
 * /support directly — is sent to the public /faqs chat.
 */
const SupportAnonymousRedirect: FC = () => {
  const {search} = useLocation();

  if (new URLSearchParams(search).has('conversation')) {
    return <Navigate to={`${LOGIN_PATH}?redirect=${encodeURIComponent(`${SUPPORT_PATH}${search}`)}`} replace />;
  }

  return <Navigate to={FAQS_PATH} replace />;
};

export {SupportAnonymousRedirect};
